import { NavigationMockApi } from '#root/mock-api/common/navigation/api';

export const mockServices = [
    NavigationMockApi,
];
